import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule, MatRowDef } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import { Subject } from "rxjs";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { ICreateBusinessPartnerSchedule } from "../interfaces/create-business-partner-schedule.interface";
import {
  BusinessPartnerScheduleAttributes,
  ScheduleTypeEnum,
} from "@albatrosdeveloper/ave-models-package";
import { getUTCHourFromLocal } from "app/utils/get-local-hour-from-utc";
import { BusinessPartnerScheduleService } from "../business-partner-schedule.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IUpdateBusinessPartnerSchedule } from "../interfaces/update-business-partner-schedule.interface";

@Component({
  selector: "app-add-business-partner-schedule-modal",
  styleUrl: "./add-business-partner-schedule.component.scss",
  templateUrl: "./add-business-partner-schedule.component.html",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
  ],
})
export class AddBusinessPartnerScheduleComponent {
  currentBusinessPartnerSchedule: ICreateBusinessPartnerSchedule =
    this.initializeCreateBusinessPartnerOrder();

  daysList: { day: string; value: number }[] = [
    { day: "LUNES", value: 1 },
    { day: "MARTES", value: 2 },
    { day: "MIÉRCOLES", value: 3 },
    { day: "JUEVES", value: 4 },
    { day: "VIERNES", value: 5 },
    { day: "SÁBADO", value: 6 },
    { day: "DOMINGO", value: 7 },
  ];
  isEditMode: boolean;

  protected _onDestroy = new Subject<void>();
  constructor(
    private readonly bpScheduleService: BusinessPartnerScheduleService,
    private readonly snackBar: MatSnackBar,
    public readonly dialogRef: MatDialogRef<AddBusinessPartnerScheduleComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      businessPartnerMongoId: string;
      type: ScheduleTypeEnum;
      schedule?: BusinessPartnerScheduleAttributes;
    }
  ) {
    this.isEditMode = !!data.schedule;
    if (this.isEditMode) {
      this.currentBusinessPartnerSchedule = {
        day: data.schedule.day,
        hourStart: data.schedule.hourStart,
        hourEnd: data.schedule.hourEnd,
      };
    }
  }

  private initializeCreateBusinessPartnerOrder(): ICreateBusinessPartnerSchedule {
    return {
      day: null,
      hourStart: null,
      hourEnd: null,
    };
  }

  save() {
    if (
      this.currentBusinessPartnerSchedule.hourStart >=
      this.currentBusinessPartnerSchedule.hourEnd
    ) {
      this.snackBar.open(
        "La hora de inicio no puede ser mayor o igual que la hora de fin.",
        "Cerrar",
        { duration: 3000 }
      );
      return;
    }

    const dataToSend = Object.entries({
      day: this.currentBusinessPartnerSchedule.day,
      hourStart: getUTCHourFromLocal(
        this.currentBusinessPartnerSchedule.hourStart
      ),
      hourEnd: getUTCHourFromLocal(this.currentBusinessPartnerSchedule.hourEnd),
    }).reduce((acc, [key, value]) => {
      if (value !== "" && !(Array.isArray(value) && value.length === 0)) {
        acc[key] = value;
      }
      return acc;
    }, {});

    if (this.data.schedule)
      this.updateBPSchedule(
        this.data.schedule,
        dataToSend as IUpdateBusinessPartnerSchedule
      );
    else this.createBPSchedule(dataToSend as ICreateBusinessPartnerSchedule);
  }

  createBPSchedule(result: ICreateBusinessPartnerSchedule): void {
    this.bpScheduleService
      .create({
        ...result,
        businessPartnerMongoId: this.data.businessPartnerMongoId,
        type: this.data.type,
      })
      .subscribe({
        next: () => {
          this.snackBar.open("Registro creado con éxito.", "Cerrar", {
            duration: 3000,
          });
          this.dialogRef.close(result);
        },
        error: (err) => {
          this.snackBar.open(
            err.error.message || "Error al crear el registro.",
            "Cerrar",
            { duration: 3000 }
          );
        },
      });
  }

  updateBPSchedule(
    schedule: BusinessPartnerScheduleAttributes,
    result: IUpdateBusinessPartnerSchedule
  ): void {
    this.bpScheduleService.update(schedule._id.toString(), result).subscribe({
      next: () => {
        this.snackBar.open("Registro actualizado con éxito.", "Cerrar", {
          duration: 3000,
        });
        this.dialogRef.close(result);
      },
      error: (err) => {
        this.snackBar.open(
          err.error.message || "Error al actualizar el registro.",
          "Cerrar",
          { duration: 3000 }
        );
      },
    });
  }
}
